module.exports = __webpack_public_path__ + "Montserrat-LightItalic.428b2306e9c744455605.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/ranjith/eclipse-workspace/monarch-web-contentful/src/assets/fonts/montserrat/Montserrat-LightItalic.ttf
// module id = ../../../../../src/assets/fonts/montserrat/Montserrat-LightItalic.ttf
// module chunks = styles